import { cloneDeep } from 'lodash';

const PERFORMERS_DEFAULT = [
  ['Missionaries', 'Missionaries', 'Must Retain', 'Bar Raisers'],
  ['Missionaries', 'Missionaries', 'Must Retain', 'Must Retain'],
  ['Can Recover', 'Can Recover', 'Over Performer', 'Over Performer'],
  ['Must Change', 'Must Change', 'Over Performer', 'Over Performer'],
].reverse();

const CALIBRATION_GRID_COLORS_DEFAULT = [
  ['blue', 'blue', 'green', 'green'],
  ['blue', 'blue', 'green', 'green'],
  ['orange', 'orange', 'red', 'red'],
  ['grey', 'grey', 'red', 'red'],
].reverse();

const breakRangeInScore = (maxLimit, parts) => {
  const factor = Number(maxLimit) / Number(parts);
  const arr = Array.from({ length: parts + 1 }, (v, idx) => Math.round((idx * factor + Number.EPSILON) * 100) / 100);
  arr[0] = 0;
  arr[parts] = maxLimit;
  return arr;
};

// In 1x3 since it's 1D, we will have OVERALL in scoreRange.
// for anything other tna 1x3, it'll be 2D hence 2 axes and
// that's why we take POTENTIAL and PERFORMANCE.
const generateScoreRange = ({
  type = 'OVERALL',
  horizontal = 'PERFORMANCE',
  horizontalScoreScale,
  verticalScoreScale,
  idx,
  vertIdx,
}) => {
  const scoreRange = {};

  if (type === 'OVERALL') {
    scoreRange.OVERALL = {
      minScore: horizontalScoreScale[idx],
      maxScore: horizontalScoreScale[idx + 1],
    };
  } else if (horizontal === 'POTENTIAL') {
    scoreRange.POTENTIAL = {
      minScore: horizontalScoreScale[idx],
      maxScore: horizontalScoreScale[idx + 1],
    };
    scoreRange.PERFORMANCE = {
      minScore: verticalScoreScale[vertIdx],
      maxScore: verticalScoreScale[vertIdx + 1],
    };
  } else {
    scoreRange.PERFORMANCE = {
      minScore: horizontalScoreScale[idx],
      maxScore: horizontalScoreScale[idx + 1],
    };
    scoreRange.POTENTIAL = {
      minScore: verticalScoreScale[vertIdx],
      maxScore: verticalScoreScale[vertIdx + 1],
    };
  }
  return scoreRange;
};

const getRandomString = (idx, vertIdx, rows) => {
  const reducedPerformersText = PERFORMERS_DEFAULT.slice(0, rows);
  return reducedPerformersText[vertIdx][idx];
};

const generateColumns = ({ rows, cols, horizontal, horizontalScoreScale, verticalScoreScale, vertIdx }) => {
  const colorMapReduced = CALIBRATION_GRID_COLORS_DEFAULT.slice(0, rows);
  const arr = Array.from({ length: cols }, (val, idx) => ({
    columnNumber: idx + 1,
    color: colorMapReduced[vertIdx][idx],
    label: getRandomString(idx, vertIdx, rows),
    scoreRange: generateScoreRange({
      type: rows === 1 ? 'OVERALL' : null,
      horizontal,
      horizontalScoreScale,
      verticalScoreScale,
      idx,
      vertIdx,
    }),
  }));
  return arr;
};

export const generateRows = ({ rows, cols, horizontal = 'PERFORMANCE', maxScore }) => {
  const obj = {};

  const horizontalScoreScale = breakRangeInScore(maxScore, cols);

  const verticalScoreScale = breakRangeInScore(maxScore, rows);

  Array.from({ length: rows }).forEach((v, idx) => {
    obj[idx + 1] = generateColumns({
      rows,
      cols,
      horizontal,
      horizontalScoreScale,
      verticalScoreScale,
      vertIdx: idx,
    });
  });
  return obj;
};

export const replaceNewScore = (grid, newScore, oldScore, direction = 'OVERALL') => {
  const newGrid = {};
  Object.keys(grid).forEach((key) => {
    newGrid[key] = grid[key].map((tile) => {
      const newTile = cloneDeep(tile);
      newTile.scoreRange[direction].minScore =
        tile.scoreRange[direction].minScore === oldScore ? newScore : tile.scoreRange[direction].minScore;
      newTile.scoreRange[direction].maxScore =
        tile.scoreRange[direction].maxScore === oldScore ? newScore : tile.scoreRange[direction].maxScore;
      return newTile;
    });
  });
  return newGrid;
};
